module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA/UlEQVQ4jZ2TPY6DMBCFPyMay42dbdPsibIXQByDhlQxEhwDcYHkYBtBgUyFt0iMvH/A7quex29+nkYjALquO43jWAIvwMw6EuBdKWWzLLuJtm1PzrnrRtKPUEq9pc65cwj0fY/3fjVJCIHWGoBxHM8pcAjJRVHs6tw0TShySHh63uocI9LOaWBaa8qy3GXheDwu76XAMAxYa3dNEFkgWWaZH9uz1i6FfuNB+2mCAOfcJo/xrUBVVZs8RvI1sMfC6gT/sZDAYz17LQQtkKTAHXg1xlDX9SLy3i/CmAMYYwK9p1LKyzRNV+99/LELSqmLAHhe5J/OWUpp8zy/fQAz3IWvDg2CYgAAAABJRU5ErkJggg=="


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/datatable.png
 ** module id = 207
 ** module chunks = 0 1
 **/